<script>
    import FilterEditHeader from '@/components/page-filter-edit/filter-edit/FilterEditHeader.vue';
    import FilterEditData from '@/components/page-filter-edit/filter-edit/FilterEditData.vue';
    import FilterEditImage from '@/components/page-filter-edit/filter-edit/FilterEditImage.vue';

    export default {
        computed: {
            isShow() {return this.$store.getters.IS_SHOW_FILTER_EDIT}
        },
        components: {
            FilterEditHeader: FilterEditHeader,
            FilterEditData: FilterEditData,
            FilterEditImage: FilterEditImage,
        }
    }
</script>


<template>
    <div
        v-if="isShow === true"
        class="left_additional_container"
    >
        <FilterEditHeader />
        <hr class="hr_light_98">
        <FilterEditData />
        <hr class="hr_light_98">
        <FilterEditImage />
    </div>
</template>